// 改变下路由地址host
 let baseUrl = 'mpserver.tt.cn';
// let baseUrl = "tt.mp.eastday.com:8582";
//  if (document.location.protocol == 'https:') {
//    // var host = "https://"+window.location.host;;
//    var host = 'https://';
//  } else {
//   //  var host = "http://"+window.location.host;;
//    var host = 'http://';
//  }
 var host = 'https://'
 host = host + baseUrl;
 const dfapi = {
   loginCode: host + '/east-usercenter/util/getVerifyImgCode', // 登陆页验证码
   login: host + '/east-usercenter/login/mobile_login', // 登录
   logout: host + '/east-usercenter/login/login_out', // 退出
   checkMobile: host + '/east-usercenter/user_center/check_mobile', // 检查手机号是否被注册
   regist: host + '/east-usercenter/user_center/register_one_m', // 注册第一步
   register_two: host + '/east-usercenter/user_center/register_two', // 注册第二步
   register_three_1: host + '/east-usercenter/user_center/register_three_1', // 注册第三步
   registCode: host + '/east-usercenter/util/sendVerification', // 注册发送验证码
   fileUpload: host + '/fileUpload', // 上传图片
   upload: host + '/east-usercenter/util/uploadImg', // 上传图片2
   cutImg: host + '/east-usercenter/util/cutImg',
   crzType: host + '/registsetpt', // 选择入驻类型
   ruzhuType: host + '/registsetpth', // 入驻信息
   EditPassword: host + '/EditPassword', // 修改密码
   getmaininfo: host + '/east-content/dfh/contentModule/publishArticleController/getContentListInfo', // 获取文章列表
   getuserinfo: host + '/east-usercenter/user_center/user_manager/usercenter1', // 获取个人信息
   getPageview: host + '/east-content/dfh/contentModule/publishArticleController/getReadPvCommentPvReward', // 获取阅读量评论量
   checkAppToken: host + '/checkAppToken', // ��ȡ�Ķ���������
   datatotal: host + '/east-usercenter/h5/user_center/datatotal', // 首页第一行统计数
   getContentRecommends: host + '/getContentRecommends', // 推荐阅读接口
   getUserRecommends: host + '/getUserRecommends', // 优质用户接口
   getReadPvRecommends: host + '/getReadPvRecommends', // 阅读量异步加载接口
   getmessagelist: host + '/east-other/message/getMessageList', // 消息中心接口
   h5TabulateData: host + '/east-usercenter/h5/user_center/h5TabulateData', // 增量对比接口
   searchcontent: host + '/east-content/dfh/contentModule/publishArticleController/getContentListInfo', // 文章管理搜索接口
   withdrawcontent: host + '/east-content/dfh/contentModule/publishArticleController/addBlackOrCancel', // 撤回文章
   deldraftlist: host + '/east-content/dfh/contentModule/selfMediaDraftController/deleteSelfMediaDraft/', // 草稿删除文章
   delcontent: host + '/east-content/dfh/contentModule/publishArticleController/deleteContent', // 删除文章
   atlasUpload: host + '/atlasUpload', // 图集页内容
   uploadVideo: host + '/uploadVideo', // 图集页内容
   datasurvey: host + '/east-content/userdata/datasurvey', // 数据分析查询
    // checkAppToken: host + "/checkAppToken", //验证App
   getArticleCanPublish: host + '/east-content/dfh/contentModule/publishArticleController/getArticleCanPublish', // 获取发文限制数量
   insertImgUrl: host + '/east-content/dfh/contentModule/ueditor/config?action=uploadimage&encode=utf-8', // 文章内图片上传接口
   originalImageUpload: host + '/east-content/dfh/contentModule/originalFileUploadController/originalImageUpload', // 封面上传
   publishNewArticle: host + '/east-content/dfh/contentModule/publishArticleController/publishNewArticle', // 发布文章
   '': ''
 };
 export default dfapi;



// WEBPACK FOOTER //
// ./src/axios/index.js